<script lang="ts">
  import { browser } from '$app/environment';
  import { goto } from '$app/navigation';
  import { page } from '$app/stores';
  import { onMount } from 'svelte';

  // hide content until we know if we should retry
  let display = false;

  onMount(async () => {
    if ($page.status == 500) {
      // retry if 500 and query param 'r' is not set
      if (browser && !('r' in $page.url.searchParams.keys())) {
        console.log('retrying...');
        await goto('?r=1', { replaceState: true });
      }
    }
    display = true;
  });
</script>

<svelte:head>
  <title>{$page.error?.message ?? 'Not Found'}</title>
</svelte:head>
{#if display}
  <div
    class="grid min-h-full place-items-center px-6 py-24 text-center sm:py-32 lg:px-8"
  >
    <p class="text-base font-semibold text-purple-800">{$page.status}</p>
    <h1
      class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl"
    >
      {$page.error?.message}
    </h1>
    <p class="mt-6 text-base leading-7 text-gray-600">
      Sorry, we had some trouble with that one.
    </p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <a href="/" class="text-sm font-semibold text-gray-900"
        ><span aria-hidden="true">&larr;</span> Go back home</a
      >
      <a
        href="mailto:support@betwatch.com"
        class="text-sm font-semibold text-gray-900"
        >Contact support <span aria-hidden="true">&rarr;</span></a
      >
    </div>
    {#if $page.status == 500}
      <a
        href="?r=1"
        class="mt-5 rounded-md bg-purple-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600"
        >Try Again</a
      >
    {/if}
  </div>
{/if}
